import { useSyncExternalStore } from 'react';
import { frameCache } from './cache';
import type { CacheMetrics } from './FrameCache';

/**
 * Subscribe the UI to live cache metrics. `useSyncExternalStore` is React 18's
 * idiomatic way to bind a mutable external store — the cache emits on every
 * state change and we re-render with the new immutable snapshot.
 */
export function useCacheMetrics(): CacheMetrics {
  return useSyncExternalStore(frameCache.subscribe, frameCache.getSnapshot);
}
